<div
      style="
        max-width: 1000px;
        margin: 0 auto;
        padding: 0 0 300px;
        border: 1px solid #ccc;
        border-radius: 10px;
        position: relative;
        margin-bottom: 20px;
        font-family: Arial, sans-serif;
      "
    >
      <div
        style="
          background-color: #d7d7f7;
          padding: 40px;
          text-align: center;
          font-size: 20px;
          font-weight: bold;
        "
      ></div>
      <div style="padding: 30px">
        <h2><b>Student Details Form</b></h2>
        <div style="margin-bottom: 15px">
          <label
            for="coun-id"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >CAMS ID
          </label>
          <input
            type="text"
            id="coun-id"
            name="coun-id"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="student-name"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Student Name</label
          >
          <input
            type="text"
            id="student-name"
            name="student-name"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="university-name"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >University Name</label
          >
          <input
            type="text"
            id="university-name"
            name="university-name"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="phone-number"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Phone Number</label
          >
          <input
            type="text"
            id="phone-number"
            name="phone-number"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="whatsapp-number"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >WhatsApp Number</label
          >
          <input
            type="text"
            id="whatsapp-number"
            name="whatsapp-number"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="email-id"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Email ID</label
          >
          <input
            type="text"
            id="email-id"
            name="email-id"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="emergency-number"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Emergency Number</label
          >
          <input
            type="text"
            id="emergency-number"
            name="emergency-number"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <div style="margin-bottom: 15px">
          <label
            for="belong-to"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Belongs To
          </label>
          <input
            type="text"
            id="belong-to"
            name="belong-to"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>
        <br />
        <br />
        <h2><b>Compulsory Questions</b></h2>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question1"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >1. Which university and course have you applied for? And what is
              your course duration?</label
            >
            <textarea
              id="question1"
              name="question1"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks1"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks1"
              name="remarks1"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question2"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >2. Are you married? Do you have kids? Will they travel as
              dependents with you?</label
            >
            <textarea
              id="question2"
              name="question2"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks2"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks2"
              name="remarks2"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question3"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >3. Do you have a personal visa refusal from UK or any other
              country? If yes, what was the visa category and reason of
              refusal?</label
            >
            <textarea
              id="question3"
              name="question3"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks3"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks3"
              name="remarks3"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question4"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >4. Which other university you have applied to? Why this
              university?</label
            >
            <textarea
              id="question4"
              name="question4"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks4"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks4"
              name="remarks4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >5. What are your plans after completion of course?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >6. How will this course help you with your future plan?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >7. This course was available in India as well, so why not
              India?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >8. Why do you want to study in UK and why not any other
              country?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >9. What was your previous qualification and when was it
              completed?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >10. What were you doing after completion of your last
              qualification till date?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <h2><b>University and Living-Expense Questions </b></h2>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >11. Where is University located?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >12. Where will you stay in the UK during your studies ?How much
              will it cost?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >13. How will you travel to the university each day and how much
              will this cost?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >14. Have you previously studied in UK? If yes what are the
              details and was there overstay of visa or deported for any
              reason.</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >15. Provide details about two or three specific modules from the
              course you have chosen and name all course modules.</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >16. How is the course assessed and how many hours of study a day
              or per week?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >17. What is your Tuition fee?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >18. What will be your Living Expense?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >19. What is the University ranking in UK and World? Please
              provide source of information on this details.</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >20. If you intend to work in the UK, do you know how many hours
              you are allowed to work?(HC)</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >20. Do you have relatives who have studied at a similar level or
              have studied overseas?</label
            >
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >21. Do you plan to do part time jobs in UK and stay back?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >22. Do you plan to do part time jobs in UK and stay back?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <h2><b>Financial Questions</b></h2>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >23. What is your current occupation (if currently employed)?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >24. Who is financing your studies?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >25. What is the profession of your financial sponsor and what
              relationship are they to you?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >26. What is your parents annual income?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >27. In case of UG Student only - How will you fund your remaining
              years of study and what evidence do you have for same?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >28. How many depends does your sponsor has?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >29. How are you showing funds for visa?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >30. Will you bring dependents along with you? If yes how will you
              show funds for them
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>
        <h2><b>Additional Questions</b></h2>
        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >31. How long it will take to reach to the campus?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <div
          style="margin-bottom: 15px; display: flex; align-items: flex-start"
        >
          <div style="width: 75%">
            <label
              for="question5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >32. How much do you expect to be earning?
            </label>
            <textarea
              id="question5"
              name="question5"
              rows="4"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            ></textarea>
          </div>
          <div style="width: 20%; margin-left: 5%">
            <label
              for="remarks5"
              style="display: block; margin-bottom: 5px; font-weight: bold"
              >Remarks</label
            >
            <input
              type="text"
              id="remarks5"
              name="remarks5"
              style="
                width: 100%;
                padding: 8px;
                box-sizing: border-box;
                border: 1px solid #ccc;
                border-radius: 4px;
              "
            />
          </div>
        </div>

        <h2><b>Decision</b></h2>
        <div>
          <label
            for="question5"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Duration of Interview
          </label>
          <input
            type="text"
            id="remarks5"
            name="remarks5"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>

        <br />

        <div>
          <label
            for="question5"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Interview Status
          </label>
          <input
            type="text"
            id="remarks5"
            name="remarks5"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          />
        </div>

        <br />

        <div>
          <label
            for="question5"
            style="display: block; margin-bottom: 5px; font-weight: bold"
            >Final Remarks
          </label>

          <textarea
            id="question5"
            name="question5"
            rows="4"
            style="
              width: 100%;
              padding: 8px;
              box-sizing: border-box;
              border: 1px solid #ccc;
              border-radius: 4px;
            "
          ></textarea>
        </div>
      </div>
    </div>